export const OFFER_DEMAND_STATUS = {
  new: 'new',
  processing: 'processing',
  to_correct: 'to_correct',
  to_moderation: 'to_moderation',
  approved: 'approved',
  rejected: 'rejected',
};
